import { View } from 'product-list/types/View'
import { useResponsiveBehaviors } from 'responsive/hooks/useResponsiveBehaviors/useResponsiveBehaviors'

export const usePageSize = (view: View) =>
	useResponsiveBehaviors<View, number>(
		{
			[View.Inspirational]: {
				default: 4,
				largeOrGreater: 8,
			},
			[View.Standard]: {
				default: 12,
				largeOrGreater: 24,
			},
			[View.Overview]: {
				default: 24,
				largeOrGreater: 28,
			},
		},
		view
	)
